import { connect } from 'react-redux';

import { StoreState } from '../../../../reducers';
import LinkPanel from '../../../../components/Editor/EditPanel/LinkPanel';
import { EditorType } from '../../constants';

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		editor: {
			slider: { totalPages },
			type,
		},
	} = state;

	return {
		...ownProps,
		totalPages,
		isUrlLinkOnly: type === EditorType.HTML,
	};
};

export default connect(mapStateToProps)(LinkPanel);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/EditPanel/LinkPanel/index.tsx